import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Waitlist({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <Waitlist.Outline {...props} />
  ) : (
    <Waitlist.Solid {...props} />
  );
}

Waitlist.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
          className="icon-outline"
        />
        <path
          d="M11.5723 3.51077C11.5306 2.68339 12.1706 1.96719 12.995 2.04962C13.9457 2.14469 14.8805 2.37579 15.7703 2.73799C17.1246 3.2893 18.3416 4.13091 19.3354 5.20353C20.3292 6.27614 21.0757 7.55365 21.5223 8.94604C21.8156 9.8608 21.9749 10.8105 21.9973 11.7657C22.0167 12.5939 21.2538 13.1776 20.432 13.073C19.6102 12.9684 19.0457 12.212 18.9731 11.3868C18.9277 10.8703 18.8249 10.3589 18.6656 9.86223C18.353 8.88756 17.8304 7.9933 17.1348 7.24247C16.4391 6.49164 15.5872 5.90251 14.6392 5.51659C14.1561 5.31994 13.654 5.17849 13.1425 5.09386C12.3252 4.95865 11.614 4.33815 11.5723 3.51077Z"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
          className="icon-outline"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Waitlist.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
          fill="currentColor"
          fillOpacity="0.4"
          className="icon-secondary"
        />
        <path
          d="M11.5723 3.51077C11.5306 2.68339 12.1706 1.96719 12.995 2.04962C13.9457 2.14469 14.8805 2.37579 15.7703 2.73799C17.1246 3.2893 18.3416 4.13091 19.3354 5.20353C20.3292 6.27614 21.0757 7.55365 21.5223 8.94604C21.8156 9.8608 21.9749 10.8105 21.9973 11.7657C22.0167 12.5939 21.2538 13.1776 20.432 13.073C19.6102 12.9684 19.0457 12.212 18.9731 11.3868C18.9277 10.8703 18.8249 10.3589 18.6656 9.86223C18.353 8.88756 17.8304 7.9933 17.1348 7.24247C16.4391 6.49164 15.5872 5.90251 14.6392 5.51659C14.1561 5.31994 13.654 5.17849 13.1425 5.09386C12.3252 4.95865 11.614 4.33815 11.5723 3.51077Z"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
